export default ['$scope', function ($scope) {
    var ctrl = this;

    $scope.tabs = [];
    ctrl.tabs = $scope.tabs;
    var tabs = ctrl.tabs;

    ctrl.select = function (tab) {
        angular.forEach(tabs, function (_tab) {
            _tab.active = false;
        });
        tab.active = true;
    };

    ctrl.addTab = function addTab(tab) {
        tabs.push(tab);
        if (tabs.length === 1 || tab.active) {
            ctrl.select(tab);
        }
    };

    ctrl.removeTab = function removeTab(tab) {
        var index = tabs.indexOf(tab);
        // Select a new tab if the tab to be removed is selected
        if (tab.active && tabs.length > 1) {
            // If this is the last tab, select the previous tab. else, the next tab.
            var newActiveIndex = index === tabs.length - 1 ? index - 1 : index + 1;
            ctrl.select(tabs[newActiveIndex]);
        }
        tabs.splice(index, 1);
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tabs/TabsetCtrl.js
// module id = 1153
// module chunks = 0